import {
  LESS_768_MEDIA_QUERY,
} from '../../../consts/adaptive';
import { cssToObject } from '../../../../utils/cssToObject';
import { defaultTheme } from 'sletat-ui-components2/dist/theme';

const {theme} = defaultTheme;

export const styles = {
  container: {
    ...cssToObject(theme.mixin.fontTextS),
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginTop: 16,
    color: theme.colorVariables.textNoteDark,

    [LESS_768_MEDIA_QUERY]: {
      marginTop: 8,
      color: theme.colorVariables.textDark,
    },
  },

  row: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },

  item: {
    marginTop: 8,
    marginRight: 8,

    '&:last-child': {
      marginRight: 0,
    }
  },

  ratingBg: {
    [LESS_768_MEDIA_QUERY]: {
      background: theme.colorVariables.bgPrimary,
    },
  },
};

export type ComponentJSSClasses = typeof styles;
